





















































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
/* 画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
/* ストア、定数関連 */
import { fileUploadModule } from '../../Uketsuke/store/modules/FileUpload'; // アップロードファイルモジュール
import axios from 'axios';
import VariableFileInput from '../../CommonUtils/basics/VariableFileInput.vue';
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import router from '../../router';
import { ScreenName } from '@/CommonUtils/fixed/ScreenName';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { loadingControlModule } from '../../store/modules/LoadingControl';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class FileUpload extends ApiAccessBase {
  // axiosの共通設定
  protected axiosApi = axios.create();
  // 検索結果ヘッダの設定
  private headers = [{}];
  // 共通パス
  private appAath = Constants.UKETSUKE_URL + '/application/' + applicationFormModule.GET_APP_TYPE;

  private mode: boolean = true; //画面モード(非 参照モード)

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '添付ファイルアップロード';
    this.screenRemarks = '※この画面では必須チェックは行われませんが、必須マーク付きのファイルは提出時に必須となります。';
    fileUploadModule.moduleReset(); //必須項目チェック用にリセット
    if (supervisingModule.GET_MODE === ScreenMode.READ) {
      this.mode = false; //画面モード設定(参照モード)
    }
    let path = this.appAath;
    // ファイルアップロード 可変項目取得
    path = this.appAath + '/fileupload' + '/init';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          //検索結果.ボタンの設定
          this.headers.shift(); //先頭の空白列削除
          this.headers.push(
          {text: 'ダウンロード',
            align: 'center',
            sortable: false,
            value: 'edit',
            width: 90,
          },
          {
            text: '削除',
            align: 'center',
            sortable: false,
            value: 'delete',
            width: 90,
          });
          //検索結果.DBから展開
          for (const item of this.variablecols['fileDownload'] ) {
            this.headers.push({text: item.label,
                              align: item.align,
                              sortable: item.sortable,
                              value: item.name,
                              width: item.width,
                              } );
          }
          //ファイル一覧検索
          path = this.appAath + '/filedownload' + '/search' + '/' + applicationFormModule.GET_TRADER_ID;
          this.apiAccess(path, Constants.API_METHOD_POST, true, true);
        }
      },
    );
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['fileUpload', 'fileDownload']);
  }

　/**
　　* ファイルアップロード
　　*/
  private upload() {
    let path = this.appAath;
    const formData2 = new FormData();
    // formのバリデーション（※この画面では必須チェックは行わない）
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // 登録しようとしているファイルが0件の場合
    if (!fileUploadModule.IS_GET_FILE_UMU) {
      return;
    }
    if (window.confirm(Message.I0003)) {
      loadingControlModule.startLoading();
      for (const variablecol of Object.keys(this.variablecols)) {
        // 可変項目の使用有無判定
        if (this.variablecolsState[variablecol]) {
          for (const col of Object.keys(this.variablecols[variablecol])) {
            formData2.delete('codeNo' + (Number(col) + 1)); //コード番号 前回情報を削除
            formData2.delete('file' + (Number(col) + 1)); //実体ファイル 前回情報を削除
            // 送信用フォームにコード番号をセット
            // formData2.append('codeNo' + (Number(col) + 1) , this.variablecols[variablecol][col].value);
          }
        }
      }

      if (fileUploadModule.uploadFile1) {
        if (fileUploadModule.uploadFile1.name) {
          formData2.append('file1', fileUploadModule.uploadFile1);
          formData2.append('codeNo1', fileUploadModule.codeNo1);
        }
      }
      if (fileUploadModule.uploadFile2) {
        if (fileUploadModule.uploadFile2.name) {
          formData2.append('file2', fileUploadModule.uploadFile2);
          formData2.append('codeNo2', fileUploadModule.codeNo2);
        }
      }
      if (fileUploadModule.uploadFile3) {
        if (fileUploadModule.uploadFile3.name) {
          formData2.append('file3', fileUploadModule.uploadFile3);
          formData2.append('codeNo3', fileUploadModule.codeNo3);
        }
      }
      if (fileUploadModule.uploadFile4) {
        if (fileUploadModule.uploadFile4.name) {
          formData2.append('file4', fileUploadModule.uploadFile4);
          formData2.append('codeNo4', fileUploadModule.codeNo4);
        }
      }
      if (fileUploadModule.uploadFile5) {
        if (fileUploadModule.uploadFile5.name) {
          formData2.append('file5', fileUploadModule.uploadFile5);
          formData2.append('codeNo5', fileUploadModule.codeNo5);
        }
      }
      if (fileUploadModule.uploadFile6) {
        if (fileUploadModule.uploadFile6.name) {
          formData2.append('file6', fileUploadModule.uploadFile6);
          formData2.append('codeNo6', fileUploadModule.codeNo6);
        }
      }
      if (fileUploadModule.uploadFile7) {
        if (fileUploadModule.uploadFile7.name) {
          formData2.append('file7', fileUploadModule.uploadFile7);
          formData2.append('codeNo7', fileUploadModule.codeNo7);
        }
      }
      if (fileUploadModule.uploadFile8) {
        if (fileUploadModule.uploadFile8.name) {
          formData2.append('file8', fileUploadModule.uploadFile8);
          formData2.append('codeNo8', fileUploadModule.codeNo8);
        }
      }
      if (fileUploadModule.uploadFile9) {
        if (fileUploadModule.uploadFile9.name) {
          formData2.append('file9', fileUploadModule.uploadFile9);
          formData2.append('codeNo9', fileUploadModule.codeNo9);
        }
      }
      if (fileUploadModule.uploadFile10) {
        if (fileUploadModule.uploadFile10.name) {
          formData2.append('file10', fileUploadModule.uploadFile10);
          formData2.append('codeNo10', fileUploadModule.codeNo10);
        }
      }
      if (fileUploadModule.uploadFile11) {
        if (fileUploadModule.uploadFile11.name) {
          formData2.append('file11', fileUploadModule.uploadFile11);
          formData2.append('codeNo11', fileUploadModule.codeNo11);
        }
      }
      if (fileUploadModule.uploadFile12) {
        if (fileUploadModule.uploadFile12.name) {
          formData2.append('file12', fileUploadModule.uploadFile12);
          formData2.append('codeNo12', fileUploadModule.codeNo12);
        }
      }
      if (fileUploadModule.uploadFile13) {
        if (fileUploadModule.uploadFile13.name) {
          formData2.append('file13', fileUploadModule.uploadFile13);
          formData2.append('codeNo13', fileUploadModule.codeNo13);
        }
      }
      if (fileUploadModule.uploadFile14) {
        if (fileUploadModule.uploadFile14.name) {
          formData2.append('file14', fileUploadModule.uploadFile14);
          formData2.append('codeNo14', fileUploadModule.codeNo14);
        }
      }
      if (fileUploadModule.uploadFile15) {
        if (fileUploadModule.uploadFile15.name) {
          formData2.append('file15', fileUploadModule.uploadFile15);
          formData2.append('codeNo15', fileUploadModule.codeNo15);
        }
      }
      if (fileUploadModule.uploadFile16) {
        if (fileUploadModule.uploadFile16.name) {
          formData2.append('file16', fileUploadModule.uploadFile16);
          formData2.append('codeNo16', fileUploadModule.codeNo16);
        }
      }
      if (fileUploadModule.uploadFile17) {
        if (fileUploadModule.uploadFile17.name) {
          formData2.append('file17', fileUploadModule.uploadFile17);
          formData2.append('codeNo17', fileUploadModule.codeNo17);
        }
      }
      if (fileUploadModule.uploadFile18) {
        if (fileUploadModule.uploadFile18.name) {
          formData2.append('file18', fileUploadModule.uploadFile18);
          formData2.append('codeNo18', fileUploadModule.codeNo18);
        }
      }
      if (fileUploadModule.uploadFile19) {
        if (fileUploadModule.uploadFile19.name) {
          formData2.append('file19', fileUploadModule.uploadFile19);
          formData2.append('codeNo19', fileUploadModule.codeNo19);
        }
      }
      if (fileUploadModule.uploadFile20) {
        if (fileUploadModule.uploadFile20.name) {
          formData2.append('file20', fileUploadModule.uploadFile20);
          formData2.append('codeNo20', fileUploadModule.codeNo20);
        }
      }

      const config = {
          headers: {
              'content-type': 'multipart/form-data',
          },
      };
      this.errorMessage = '';
      this.infoMessage = '';
      this.warnMessage = '';
      axios
        .post(path + '/fileupload' + '/' + applicationFormModule.GET_TRADER_ID, formData2, config)
        .then((response) => {
            // response 処理
          // this.errorMessage = '';
          // メッセージの設定 template start
          if (response.data.resultMessages && response.data.resultMessages.notEmpty) {
            this.resultMessagesList = response.data.resultMessages.list;
            const isErrorMessage = response.data.resultMessages.type === 'ERROR' ? true : false;
            for (const messageIndex of Object.keys(this.resultMessagesList)) {
              const tempMessage = this.resultMessagesList[Number(messageIndex)].code + ':' + this.resultMessagesList[Number(messageIndex)].text + '\n';
              if (isErrorMessage) {
                this.errorMessage += tempMessage;
              } else {
                this.infoMessage += tempMessage;
              }
            }
          }
          // メッセージの設定 template end
            // 成功
          // alert(Message.I0004);
          //再検索前に登録成功メッセージ保持
          const successMessage = this.infoMessage;
          //ファイル一覧再検索
          path = this.appAath + '/filedownload' + '/search' + '/' + applicationFormModule.GET_TRADER_ID;
          this.apiAccess(path, Constants.API_METHOD_POST, true, true);
          //再検索後に登録成功メッセージ格納
          this.infoMessage = successMessage;
        })
        .catch((error) => {
            // 失敗
          this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
          //20250618 [ステータス変更対応] morimoto ADD Start
          //申請受付ステータスエラーの場合のみ、システムエラー画面に遷移させる。
          if (this.errorMessage.indexOf('statusSystemError')  > -1) {
            router.push({name: 'no_auth/SystemError'});
          }
          //20250618 [ステータス変更対応] morimoto ADD End
          })
        .finally(() => {
          loadingControlModule.endLoading();
        });
      // メッセージ表示位置へ移動
      this.hrefElement('app', -50);
    }
  }

  /**
　  * ファイルダウンロード
　  */
  private download(param: any) {
    let path = this.appAath;
    // ボタン押下時
    if (window.confirm(Message.I0021)) {
      path = path + '/filedownload' + '/' + applicationFormModule.GET_TRADER_ID + '/' + param.fileId;
      this.apiAccessDownload(path);
    }
  }

  /**
　  * ファイル削除
　  */
  private deleteFile(param: any) {
    if (this.variablecols['fileUpload'][param.fileId - 1].required) { //必須項目の場合ファイル削除前に確認メッセージ表示
      if (!window.confirm(Message.I0023)) {
        return;
      }
    }
    // ボタン押下時
    if (window.confirm(Message.I0029)) {
      let path = this.appAath;
      path = path + '/filedelete' + '/' + applicationFormModule.GET_TRADER_ID + '/' + param.fileId;
      // APIアクセス
      this.apiAccess(path, Constants.API_METHOD_POST, null, null)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          // 成功
          // alert(Message.I0002);
          //再検索前に削除成功メッセージ保持
          const deleteMessage = this.infoMessage;
          //ファイル一覧再検索
          path = this.appAath + '/filedownload' + '/search' + '/' + applicationFormModule.GET_TRADER_ID;
          this.apiAccess(path, Constants.API_METHOD_POST, true, true);
          //再検索後に削除成功メッセージ格納
          this.infoMessage = deleteMessage;
        } else {
          // 失敗
        }
        //20250618 [ステータス変更対応] morimoto ADD Start
        //申請受付ステータスエラーの場合のみ、システムエラー画面に遷移させる。
        if (this.errorMessage.indexOf('statusSystemError')  > -1) {
          router.push({name: 'no_auth/SystemError'});
        }
        //20250618 [ステータス変更対応] morimoto ADD End
      });
      // メッセージ表示位置へ移動
      this.hrefElement('app', -50);
    }
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    fileUploadModule.moduleReset();
    router.push('appForm');
  }
}
